module.exports = __webpack_public_path__ + "static/media/back7.850ee5d2.jpg";